import React, { useMemo } from 'react';

import { useLabels } from 'contextProviders/SplashScreenProviders/ContentProviders/LabelsProvider';
import Badge from 'kingpin/atoms/Badge';
import Tooltip from 'components/Tooltip';

const ContentLabels = ({ labelIds }: { labelIds: string[] }) => {
  const labels = useLabels(labelIds);

  const endIndex = useMemo(() => {
    if (labels.length === 2) {
      return 3;
    }

    return 1;
  }, [labels.length]);

  const visibleLabels = useMemo(() => {
    return labels.slice(0, endIndex);
  }, [endIndex, labels]);

  const hiddenLabels = useMemo(() => {
    return labels.slice(endIndex);
  }, [endIndex, labels]);

  return (
    <>
      {visibleLabels.map((label) => (
        <div style={{ width: 'fit-content' }} key={label.id}>
          <Badge badgeType={label.color} text={label.name} />
        </div>
      ))}
      {hiddenLabels.length > 0 && (
        <Tooltip content={hiddenLabels.map((l) => l.name).join(', ')}>
          <Badge
            badgeType={'Default'}
            text={`+ ${hiddenLabels.length} other${hiddenLabels.length > 1 ? 's' : ''}`}
          />
        </Tooltip>
      )}
    </>
  );
};

export default ContentLabels;
